import { useEffect } from "react";

const SITE_NAME = "Muhammad Munaf";
const DEFAULT_DESCRIPTION =
	"Muhammad Munaf is a product engineer in Islamabad, Pakistan, who designs and builds digital products, with a background in product design and UX.";

// Sets the document title and meta description for the current page.
export default function usePageMeta(title, description = DEFAULT_DESCRIPTION) {
	useEffect(() => {
		document.title = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Product Engineer`;

		const meta = document.querySelector('meta[name="description"]');
		if (meta) meta.setAttribute("content", description);
	}, [title, description]);
}
